import {
  OrderDraftPreferredCreationFlows,
  type OrderDraftPreferredCreationFlowEnum,
} from '@webapp/modules/purchasing/entities/enums/OrderDraftPreferredCreationFlowEnum'
import { type IOrderDraftRepository } from '../../interfaces/IOrderDraftRepository'

export class GetPreferredOrderRequestFlowUseCase {
  constructor(
    private readonly deps: {
      orderDraftRepository: IOrderDraftRepository
    }
  ) {}

  execute = async (
    userId: number
  ): Promise<OrderDraftPreferredCreationFlowEnum> => {
    const preferredOrderRequestFlow =
      await this.deps.orderDraftRepository.getOrderDraftPreferredCreationFlow(
        userId
      )

    if (
      preferredOrderRequestFlow === OrderDraftPreferredCreationFlows.CLASSIC ||
      preferredOrderRequestFlow === OrderDraftPreferredCreationFlows.AI
    ) {
      return preferredOrderRequestFlow
    }

    return OrderDraftPreferredCreationFlows.CLASSIC
  }
}
